module.exports = {
      id: "icon-standard-clinic-usage",
      viewBox: "0 0 26 26",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-standard-clinic",
      toString: function () {
        return this.url;
      }
    }